export const START_CALL = "START_CALL_HOMEPAGE_VET";
export const CALL_COMPLETED = "CALL_COMPLETED_HOMEPAGE_VET";
export const CATCH_ERROR = "CATCH_ERROR_HOMEPAGE_VET";
